// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"MM-z","inlineTitle":"NM-z","sponsoredAdsWrapper":"OM-z","marketplaceRecosWrapper":"PM-z"};